(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSAnio', SSAnio);

    SSAnio.$inject = ['$resource', 'DateUtils'];

    function SSAnio ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-anios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
